import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Row } from "@tanstack/react-table";
import { twJoin } from "tailwind-merge";

import { MatrixTableRow } from "src/matrixTableNode/MatrixTable";

type Props = {
  row: Row<MatrixTableRow>;
  children: React.ReactNode;
};

export const SortableRow: React.FC<Props> = ({ row, children }) => {
  const rowId = row.original.row_predicate.id;
  const { setNodeRef, transform, transition, active, isDragging } = useSortable(
    {
      id: rowId,
    },
  );

  const style = {
    transition,
    transform: CSS.Translate.toString(transform),
  };

  return (
    <tr
      ref={setNodeRef}
      className={twJoin(
        "group [&>td:first-child]:z-[16]",
        rowId === active?.id && "z-50",
        isDragging && "opacity-50",
      )}
      style={style}
    >
      {children}
    </tr>
  );
};
